import { AppThunk } from 'redux/reducers/rootReducer';
import { ITableQueryData } from 'types/frontend_models/table/ITableQueryData';
import { ITableData } from 'types/backend_models/shared/ITableData';
import { IDocument } from 'types/backend_models/documents/IDocument';
import { IGenericDataFetchParams, createGenericDataFetch } from '../../generic/GenericDataActions';
import { setFetchLibraryDocumentsPending, setFetchLibraryDocumentsSucces, setFetchLibraryDocumentsError } from 'redux/reducers/data_action_reducers/library/overview/LibraryDocumentsReducer';
import { builBackendTableQuery } from 'functions/backend/backendTableQueryBuilder';

export const initialQueryData: ITableQueryData = {
	sorted: '',
	filters: [],
	currentPage: 1,
	pageSize: 20000
}

var lastQueryData: ITableQueryData = initialQueryData;

export function getLastQueryData(): ITableQueryData
{
	return lastQueryData;
}

var fetchParams: IGenericDataFetchParams<ITableData<IDocument[]>> = {
	apiEndPoint: '',
	pendingActionCreator: setFetchLibraryDocumentsPending,
	succesActionCreator: setFetchLibraryDocumentsSucces,
	errorActionCreator: setFetchLibraryDocumentsError
}

export function fetchLibraryDocuments(data: ITableQueryData): AppThunk
{
	lastQueryData = data;
	const query = builBackendTableQuery(data);
	const queryPart2 = `documentownertypeid==2|11` //Account of Gen
	fetchParams.apiEndPoint = `customer/documents${query}${queryPart2}`;

	return createGenericDataFetch<ITableData<IDocument[]>>(fetchParams);
}